export const gtmFunction = async (url = '', label = '') => {
    if (typeof (document) !== 'undefined' && url !== '' && label !== '') {

        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('id', `${label.replace(/ /g, "_")}_script`);
        script.innerHTML = `window.dataLayer = window.dataLayer || [];`;

        script.innerHTML += `dataLayer.push({
            'event': 'click_nav_item',
            'link_url': "${url}",
            'link_text': "${label}"
        });`;
        document.querySelectorAll(`#${label.replace(/ /g, "_")}_script`).length === 0 && document.head.append(script);
    }
    return true;
};

export const clickAccordian = async (data = []) => {
    if (typeof (document) !== 'undefined' && data.length > 0) {

        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.innerHTML = `window.dataLayer = window.dataLayer || [];`;

        script.innerHTML += `dataLayer.push({
            'event': 'click_accordion',
            'action': 'open',
            'link_text': ${JSON.stringify(data.trim())},
            'type': 'Frequently asked questions'
        });`;
        document.head.append(script);
    }
    return true;
};